/* eslint-disable max-lines -- Flat icon registry; insertions are alphabetical and the count grows with the design system. */
import { ReactComponent as alert } from './assets/alert.svg';
import { ReactComponent as antibioticFree } from './assets/antibioticFree.svg';
import { ReactComponent as appetizer } from './assets/appetizer.svg';
import { ReactComponent as arrowLeft } from './assets/arrowLeft.svg';
import { ReactComponent as arrowRight } from './assets/arrowRight.svg';
import { ReactComponent as avocado } from './assets/avocado.svg';
import { ReactComponent as bellPepper } from './assets/bellPepper.svg';
import { ReactComponent as breakfast } from './assets/breakfast.svg';
import { ReactComponent as calendar } from './assets/calendar.svg';
import { ReactComponent as cart } from './assets/cart.svg';
import { ReactComponent as ccAmex } from './assets/ccAmex.svg';
import { ReactComponent as ccDiscover } from './assets/ccDiscover.svg';
import { ReactComponent as ccMastercard } from './assets/ccMastercard.svg';
import { ReactComponent as ccVisa } from './assets/ccVisa.svg';
import { ReactComponent as certified } from './assets/certified.svg';
import { ReactComponent as chat } from './assets/chat.svg';
import { ReactComponent as check } from './assets/check.svg';
import { ReactComponent as checkedCalendar } from './assets/checkedCalendar.svg';
import { ReactComponent as chefHat } from './assets/chefHat.svg';
import { ReactComponent as chefHatStar } from './assets/chefHatStar.svg';
import { ReactComponent as chevronDown } from './assets/chevronDown.svg';
import { ReactComponent as chevronLeft } from './assets/chevronLeft.svg';
import { ReactComponent as chevronRight } from './assets/chevronRight.svg';
import { ReactComponent as chevronUp } from './assets/chevronUp.svg';
import { ReactComponent as cilantro } from './assets/cilantro.svg';
import { ReactComponent as circleCheck } from './assets/circleCheck.svg';
import { ReactComponent as clock } from './assets/clock.svg';
import { ReactComponent as close } from './assets/close.svg';
import { ReactComponent as closeWithCircle } from './assets/closeWithCircle.svg';
import { ReactComponent as dairy } from './assets/dairy.svg';
import { ReactComponent as desserts } from './assets/desserts.svg';
import { ReactComponent as dietTypeHalal } from './assets/dietTypeHalal.svg';
import { ReactComponent as dietTypeOmnivore } from './assets/dietTypeOmnivore.svg';
import { ReactComponent as dietTypePaleo } from './assets/dietTypePaleo.svg';
import { ReactComponent as dietTypePescatarian } from './assets/dietTypePescatarian.svg';
import { ReactComponent as dietTypeVegan } from './assets/dietTypeVegan.svg';
import { ReactComponent as dietTypeVegetarian } from './assets/dietTypeVegetarian.svg';
import { ReactComponent as dietTypeWhole30 } from './assets/dietTypeWhole30.svg';
import { ReactComponent as dishCloche } from './assets/dishCloche.svg';
import { ReactComponent as dollar } from './assets/dollar.svg';
import { ReactComponent as drinks } from './assets/drinks.svg';
import { ReactComponent as edit } from './assets/edit.svg';
import { ReactComponent as envelope } from './assets/envelope.svg';
import { ReactComponent as errorCircle } from './assets/errorCircle.svg';
import { ReactComponent as expandableDropdownCaret } from './assets/expandableDropdownCaret.svg';
import { ReactComponent as eyeClosed } from './assets/eyeClosed.svg';
import { ReactComponent as eyeOpen } from './assets/eyeOpen.svg';
import { ReactComponent as fall } from './assets/fall.svg';
import { ReactComponent as favorites } from './assets/favorites.svg';
import { ReactComponent as filter } from './assets/filter.svg';
import { ReactComponent as garlic } from './assets/garlic.svg';
import { ReactComponent as gift } from './assets/gift.svg';
import { ReactComponent as globe } from './assets/globe.svg';
import { ReactComponent as glp1Friendly } from './assets/glp1Friendly.svg';
import { ReactComponent as gluten } from './assets/gluten.svg';
import { ReactComponent as grassFed } from './assets/grassFed.svg';
import { ReactComponent as hamburgerMenu } from './assets/hamburgerMenu.svg';
import { ReactComponent as handServingBowl } from './assets/handServingBowl.svg';
import { ReactComponent as healthy } from './assets/healthy.svg';
import { ReactComponent as heartBowl } from './assets/heartBowl.svg';
import { ReactComponent as heartFilled } from './assets/heartFilled.svg';
import { ReactComponent as heartHandshake } from './assets/heartHandshake.svg';
import { ReactComponent as heartOutline } from './assets/heartOutline.svg';
import { ReactComponent as heartUnfilled } from './assets/heartUnfilled.svg';
import { ReactComponent as highProtein } from './assets/highProtein.svg';
import { ReactComponent as home } from './assets/home.svg';
import { ReactComponent as homemade } from './assets/homemade.svg';
import { ReactComponent as info } from './assets/info.svg';
import { ReactComponent as kidFriendly } from './assets/kidFriendly.svg';
import { ReactComponent as kidSnacks } from './assets/kidSnacks.svg';
import { ReactComponent as kosher } from './assets/kosher.svg';
import { ReactComponent as leavesCircle } from './assets/leavesCircle.svg';
import { ReactComponent as locallySourced } from './assets/locallySourced.svg';
import { ReactComponent as locationPin } from './assets/locationPin.svg';
import { ReactComponent as lockClosed } from './assets/lockClosed.svg';
import { ReactComponent as lowCalorie } from './assets/lowCalorie.svg';
import { ReactComponent as lowFodmap } from './assets/lowFodmap.svg';
import { ReactComponent as lunch } from './assets/lunch.svg';
import { ReactComponent as main } from './assets/main.svg';
import { ReactComponent as meal } from './assets/meal.svg';
import { ReactComponent as message } from './assets/message.svg';
import { ReactComponent as minus } from './assets/minus.svg';
import { ReactComponent as minusHandWritten } from './assets/minusHandWritten.svg';
import { ReactComponent as mixingBowl } from './assets/mixingBowl.svg';
import { ReactComponent as movingDish } from './assets/movingDish.svg';
import { ReactComponent as mushrooms } from './assets/mushrooms.svg';
import { ReactComponent as nativeApplePay } from './assets/nativeApplePay.svg';
import { ReactComponent as nativeGooglePay } from './assets/nativeGooglePay.svg';
import { ReactComponent as nativeGooglePayDark } from './assets/nativeGooglePayDark.svg';
import { ReactComponent as nuts } from './assets/nuts.svg';
import { ReactComponent as onions } from './assets/onions.svg';
import { ReactComponent as openPot } from './assets/openPot.svg';
import { ReactComponent as organic } from './assets/organic.svg';
import { ReactComponent as pairingDivider } from './assets/pairingDivider.svg';
import { ReactComponent as pastureRaised } from './assets/pastureRaised.svg';
import { ReactComponent as perkConcierge } from './assets/perkConcierge.svg';
import { ReactComponent as perkExclusiveChefs } from './assets/perkExclusiveChefs.svg';
import { ReactComponent as perkFreeDelivery } from './assets/perkFreeDelivery.svg';
import { ReactComponent as perkGlobalCuisines } from './assets/perkGlobalCuisines.svg';
import { ReactComponent as perkMoneyBack } from './assets/perkMoneyBack.svg';
import { ReactComponent as perkPersonalizedMenu } from './assets/perkPersonalizedMenu.svg';
import { ReactComponent as piggybankHeart } from './assets/piggybankHeart.svg';
import { ReactComponent as plus } from './assets/plus.svg';
import { ReactComponent as plusHandWritten } from './assets/plusHandWritten.svg';
import { ReactComponent as portraitAdult1 } from './assets/portraitAdult1.svg';
import { ReactComponent as portraitAdult2 } from './assets/portraitAdult2.svg';
import { ReactComponent as portraitAdult3 } from './assets/portraitAdult3.svg';
import { ReactComponent as portraitChild1 } from './assets/portraitChild1.svg';
import { ReactComponent as portraitChild2 } from './assets/portraitChild2.svg';
import { ReactComponent as portraitChild3 } from './assets/portraitChild3.svg';
import { ReactComponent as portraitLittleEater } from './assets/portraitLittleEater.svg';
import { ReactComponent as portraitSmallChild } from './assets/portraitSmallChild.svg';
import { ReactComponent as premium } from './assets/premium.svg';
import { ReactComponent as promo } from './assets/promo.svg';
import { ReactComponent as proteinBeef } from './assets/proteinBeef.svg';
import { ReactComponent as proteinChicken } from './assets/proteinChicken.svg';
import { ReactComponent as proteinEgg } from './assets/proteinEgg.svg';
import { ReactComponent as proteinFish } from './assets/proteinFish.svg';
import { ReactComponent as proteinLamb } from './assets/proteinLamb.svg';
import { ReactComponent as proteinPlant } from './assets/proteinPlant.svg';
import { ReactComponent as proteinPork } from './assets/proteinPork.svg';
import { ReactComponent as proteinShellfish } from './assets/proteinShellfish.svg';
import { ReactComponent as proteinTofu } from './assets/proteinTofu.svg';
import { ReactComponent as questionMark } from './assets/questionMark.svg';
import { ReactComponent as restrictionAvocado } from './assets/restrictionAvocado.svg';
import { ReactComponent as restrictionBeef } from './assets/restrictionBeef.svg';
import { ReactComponent as restrictionBellPepper } from './assets/restrictionBellPepper.svg';
import { ReactComponent as restrictionCilantro } from './assets/restrictionCilantro.svg';
import { ReactComponent as restrictionDairyFree } from './assets/restrictionDairyFree.svg';
import { ReactComponent as restrictionEggs } from './assets/restrictionEggs.svg';
import { ReactComponent as restrictionGarlic } from './assets/restrictionGarlic.svg';
import { ReactComponent as restrictionGlutenFree } from './assets/restrictionGlutenFree.svg';
import { ReactComponent as restrictionMushrooms } from './assets/restrictionMushrooms.svg';
import { ReactComponent as restrictionNuts } from './assets/restrictionNuts.svg';
import { ReactComponent as restrictionOnions } from './assets/restrictionOnions.svg';
import { ReactComponent as restrictionOther } from './assets/restrictionOther.svg';
import { ReactComponent as restrictionPork } from './assets/restrictionPork.svg';
import { ReactComponent as restrictionSesame } from './assets/restrictionSesame.svg';
import { ReactComponent as restrictionShellfish } from './assets/restrictionShellfish.svg';
import { ReactComponent as restrictionSoy } from './assets/restrictionSoy.svg';
import { ReactComponent as restrictionSpicyPepper } from './assets/restrictionSpicyPepper.svg';
import { ReactComponent as reusablePackaging } from './assets/reusablePackaging.svg';
import { ReactComponent as search } from './assets/search.svg';
import { ReactComponent as seedOilFree } from './assets/seedOilFree.svg';
import { ReactComponent as sesame } from './assets/sesame.svg';
import { ReactComponent as share } from './assets/share.svg';
import { ReactComponent as shefLogo } from './assets/shefLogo.svg';
import { sideCategoryIcons } from './assets/side-categories';
import { ReactComponent as sides } from './assets/sides.svg';
import { ReactComponent as soy } from './assets/soy.svg';
import { ReactComponent as spicyPepper } from './assets/spicyPepper.svg';
import { ReactComponent as spring } from './assets/spring.svg';
import { ReactComponent as starEmpty } from './assets/starEmpty.svg';
import { ReactComponent as starFilled } from './assets/starFilled.svg';
import { ReactComponent as starHalf } from './assets/starHalf.svg';
import { ReactComponent as summer } from './assets/summer.svg';
import { ReactComponent as tablerunMark } from './assets/tablerunMark.svg';
import { ReactComponent as takeoutUpgrade } from './assets/takeoutUpgrade.svg';
import { ReactComponent as target } from './assets/target.svg';
import { ReactComponent as tasteVerified } from './assets/tasteVerified.svg';
import { ReactComponent as thumbsDown } from './assets/thumbsDown.svg';
import { ReactComponent as thumbsSide } from './assets/thumbsSide.svg';
import { ReactComponent as thumbsUp } from './assets/thumbsUp.svg';
import { ReactComponent as tonyRobbinsWordmark } from './assets/tonyRobbinsWordmark.svg';
import { ReactComponent as topShef } from './assets/topShef.svg';
import { ReactComponent as trash } from './assets/trash.svg';
import { ReactComponent as trophy } from './assets/trophy.svg';
import { ReactComponent as twinklyStars } from './assets/twinklyStars.svg';
import { ReactComponent as verifiedCheck } from './assets/verifiedCheck.svg';
import { ReactComponent as wildCaught } from './assets/wildCaught.svg';
import { ReactComponent as winter } from './assets/winter.svg';
/**
 * When adding new icons, be sure that all colors in the SVG that should inherit the color are updated. This looks
 * like changing the property of all `<path>` and `<rect>` elements to use `currentColor` for any color you want
 * to be inherited (i.e. `fill="currentColor"` and `stroke="currentColor"`). Also be sure that the `<svg>` element
 * has `fill="none"` to make the background transparent.
 *
 * If you want the stroke and fill to have different colors, some more finagling is necessary.
 * Set fill="var(--svg-fill, currentColor)" and stroke="var(--svg-stroke, currentColor)" respectively
 * which uses CSS vars to achieve the separation of colors. NOTE: this only works for hexcodes, not direct
 * tailwind stylings which must be converted using theme()
 */
export const icons = {
  alert,
  antibioticFree,
  appetizer,
  arrowLeft,
  arrowRight,
  avocado,
  bellPepper,
  breakfast,
  calendar,
  cart,
  ccAmex,
  ccDiscover,
  ccMastercard,
  ccVisa,
  certified,
  chat,
  check,
  checkedCalendar,
  chefHat,
  chefHatStar,
  chevronDown,
  chevronLeft,
  chevronRight,
  chevronUp,
  cilantro,
  circleCheck,
  clock,
  close,
  closeWithCircle,
  dairy,
  desserts,
  dietTypeHalal,
  dietTypeOmnivore,
  dietTypePaleo,
  dietTypePescatarian,
  dietTypeVegan,
  dietTypeVegetarian,
  dietTypeWhole30,
  dishCloche,
  drinks,
  dollar,
  edit,
  envelope,
  errorCircle,
  expandableDropdownCaret,
  eyeClosed,
  eyeOpen,
  fall,
  favorites,
  filter,
  garlic,
  gift,
  globe,
  glp1Friendly,
  gluten,
  grassFed,
  hamburgerMenu,
  handServingBowl,
  healthy,
  heartBowl,
  heartFilled,
  heartHandshake,
  heartOutline,
  heartUnfilled,
  home,
  homemade,
  highProtein,
  info,
  kidFriendly,
  kidSnacks,
  kosher,
  leavesCircle,
  locallySourced,
  locationPin,
  lockClosed,
  lowCalorie,
  lowFodmap,
  lunch,
  main,
  meal,
  message,
  minus,
  minusHandWritten,
  mixingBowl,
  movingDish,
  mushrooms,
  nativeApplePay,
  nativeGooglePay,
  nativeGooglePayDark,
  nuts,
  onions,
  openPot,
  organic,
  pairingDivider,
  pastureRaised,
  perkConcierge,
  perkExclusiveChefs,
  perkFreeDelivery,
  perkGlobalCuisines,
  perkMoneyBack,
  perkPersonalizedMenu,
  piggybankHeart,
  plus,
  plusHandWritten,
  portraitAdult1,
  portraitAdult2,
  portraitAdult3,
  portraitChild1,
  portraitChild2,
  portraitChild3,
  portraitLittleEater,
  portraitSmallChild,
  premium,
  promo,
  proteinBeef,
  proteinChicken,
  proteinEgg,
  proteinFish,
  proteinLamb,
  proteinPlant,
  proteinPork,
  proteinShellfish,
  proteinTofu,
  questionMark,
  restrictionAvocado,
  restrictionBeef,
  restrictionBellPepper,
  restrictionCilantro,
  restrictionDairyFree,
  restrictionEggs,
  restrictionGarlic,
  restrictionGlutenFree,
  restrictionMushrooms,
  restrictionNuts,
  restrictionOnions,
  restrictionOther,
  restrictionPork,
  restrictionSesame,
  restrictionShellfish,
  restrictionSoy,
  restrictionSpicyPepper,
  reusablePackaging,
  search,
  seedOilFree,
  sesame,
  share,
  shefLogo,
  sides,
  soy,
  spicyPepper,
  spring,
  starEmpty,
  starFilled,
  starHalf,
  summer,
  tablerunMark,
  takeoutUpgrade,
  target,
  tasteVerified,
  thumbsDown,
  thumbsSide,
  thumbsUp,
  tonyRobbinsWordmark,
  topShef,
  trash,
  trophy,
  twinklyStars,
  verifiedCheck,
  wildCaught,
  winter,
  ...sideCategoryIcons,
};
